import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { LayoutDashboard, Truck, FileBarChart2, ShieldCheck, LogOut, ChevronRight, ClipboardList } from 'lucide-react';
import logo from './images/jmc-logo.png';
import { logout } from '../api';

function Layout({ children, userRole, userEmail, pageTitle, pageSubtitle }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const initials = userEmail
    ? userEmail.split('@')[0].slice(0, 2).toUpperCase()
    : 'AD';

  const navItems = [
    { to: '/Homepage', icon: <LayoutDashboard size={17} />, label: 'Dashboard' },
    { to: '/reports',  icon: <FileBarChart2 size={17} />,   label: 'Reports' },
    ...(userRole === 'superadmin'
      ? [
          { to: '/admin', icon: <ShieldCheck size={17} />, label: 'Manage Admins' },
          { to: '/activity-logs', icon: <ClipboardList size={17} />, label: 'Activity Logs' },
        ]
      : []),
  ];

  return (
    <div className="app-shell">
      {/* Sidebar */}
      <aside className="sidebar">
        <Link to="/Homepage" className="sidebar-logo">
          <img src={logo} alt="MCJS Logo" />
          <div className="sidebar-logo-text">
            <div className="brand">MCJS - OMS</div>
            <div className="sub">Vehicle Entry System</div>
          </div>
        </Link>

        <nav className="sidebar-nav">
          <div className="sidebar-section-label">Navigation</div>
          {navItems.map(item => (
            <Link
              key={item.to}
              to={item.to}
              className={`sidebar-link${location.pathname === item.to ? ' active' : ''}`}
            >
              {item.icon}
              <span style={{ flex: 1 }}>{item.label}</span>
              {location.pathname === item.to && <ChevronRight size={14} />}
            </Link>
          ))}
        </nav>

        <div className="sidebar-footer">
          <div className="sidebar-user">
            <div className="sidebar-avatar">{initials}</div>
            <div className="sidebar-user-info">
              <div className="name">{userEmail?.split('@')[0] || 'Admin'}</div>
              <div className="role">{userRole === 'superadmin' ? 'Super Admin' : 'Admin'}</div>
            </div>
          </div>
          <button className="btn-logout" onClick={handleLogout}>
            <LogOut size={15} /> Logout
          </button>
        </div>
      </aside>

      {/* Main */}
      <div className="main-content">
        <header className="topbar">
          <div>
            <div className="topbar-title">{pageTitle || 'Dashboard'}</div>
            {pageSubtitle && <div className="topbar-subtitle">{pageSubtitle}</div>}
          </div>
          <div className="topbar-right">
            <span className="topbar-badge">
              <Truck size={13} />
              {userRole === 'superadmin' ? 'Super Admin' : 'Admin'}
            </span>
          </div>
        </header>
        <div className="page-body">{children}</div>
      </div>
    </div>
  );
}

export default Layout;
